/// \file profileUseStates.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import React, {useState} from 'react';
import { profileUseStateInterface } from './profileUseStateInterface';
const profileUseStates = ():profileUseStateInterface => {

const [current, setCurrent] = useState<{
        firstName:string,
        lastName:string,
        email:string,
        office:string,
        mobile:string,
}>({
        firstName:"",
        lastName:"",
        email:"",
        office:"",
        mobile:"",        
});

const validate= (e:any) => {
  const valid = e.target.validity;
  if(valid.patternMismatch){
    e.target.value = "";
  }
};

  const pairs=[
        {name:"firstName",title:"* FIRST NAME",style:"input","values":"firstName"},
        {name:"lastName",title:"* LAST NAME",style:"input","values":"lastName"},
        {name:"email",title:"* EMAIL ADDRESS",style:"email","values":{onChange:validate}},
        {name:"office",title:"OFFICE #",style:"tel","values":{onChange:validate}},
        {name:"mobile",title:"MOBILE #",style:"tel","values":{onChange:validate}},
  ];

  const setCurrentProfile = setCurrent;
  const pairsProfile = pairs;
  return {     
    setCurrentProfile,
    pairsProfile,
  };
};

export default profileUseStates;